module.exports = __webpack_public_path__ + "img/icon-c-form.91ca7d50.svg";